import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString(),
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-card border-t border-border shadow-lg"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-4">
        <Shield className="w-5 h-5 text-primary shrink-0" />
        <p className="text-sm text-muted-foreground flex-1">
          We use essential cookies for authentication and session management only. No tracking or advertising cookies are used.
          By continuing, you agree to our{' '}
          <a href="/privacy-policy" className="underline text-primary hover:text-primary/80">
            Privacy Policy
          </a>.
        </p>
        <Button
          onClick={accept}
          size="sm"
          className="shrink-0"
          data-testid="cookie-accept-button"
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
